import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import Button from '~components/button';
import Collapsible from '~components/collapsible';

const SECTIONS = ['one', 'two', 'three', 'four', 'five'];

const FAQ = memo(({ city }) => {
  const intl = useIntl();

  // Service term and brand name come from i18n so they stay localized per domain.
  const vars = {
    city,
    serviceTerm: intl.formatMessage({ id: 'containers.city.seo.serviceTerm', defaultMessage: 'household help' }),
    domainName: intl.formatMessage({ id: 'containers.city.seo.domainName', defaultMessage: 'our website' }),
  };

  // Only render sections whose keys are actually translated for this locale.
  // Locales that have not generated the newer keys yet simply show fewer items
  // instead of a raw "Section four headline" placeholder.
  const sections = SECTIONS.filter(
    (section) =>
      intl.messages[`containers.city.seo.faq-section.section-${section}.headline`] &&
      intl.messages[`containers.city.seo.faq-section.section-${section}.content`]
  );

  if (!sections.length) return null;

  return (
    <section className="c-faq-section" aria-labelledby="city-faq-heading">
      <h2 id="city-faq-heading" className="l-headline--secondary">
        {intl.formatMessage(
          { id: 'containers.city.seo.faq-section.headline', defaultMessage: 'Top {count} most asked questions' },
          { ...vars, count: sections.length }
        )}
      </h2>
      <div className="c-faq-section__wrapper">
        {sections.map((section, index) => (
          <Collapsible.Wrapper
            key={section}
            className={
              index === 0
                ? 'c-faq-section__collapsible c-faq-section__collapsible--first'
                : 'c-faq-section__collapsible'
            }
          >
            <Collapsible.Header>
              <div className="c-faq-section-item__headline">
                {intl.formatMessage({ id: `containers.city.seo.faq-section.section-${section}.headline` }, vars)}
              </div>
            </Collapsible.Header>
            <Collapsible.Content>
              {intl.formatMessage({ id: `containers.city.seo.faq-section.section-${section}.content` }, vars)}
            </Collapsible.Content>
          </Collapsible.Wrapper>
        ))}
      </div>
      <div className="c-faq-section__button">
        <Link to={`/${intl.formatMessage({ id: 'routes.faq' })}`}>
          <Button className="c-btn--text">
            {intl.formatMessage({ id: 'containers.city.seo.faq-section.button', defaultMessage: 'Learn more' }, vars)}
          </Button>
        </Link>
      </div>
    </section>
  );
});

export default FAQ;
